export const GET_TRANSACTION_INFO_BY_ID = 'GET_TRANSACTION_INFO_BY_ID'
export const GET_TRANSACTION_INFO_BY_ID2 = 'GET_TRANSACTION_INFO_BY_ID2'
